import { gossipCollections } from "@/mocks/cg51";
import { Reveal, SectionHeading } from "./ui";

const palette = [
  "bg-primary-100 text-primary-800",
  "bg-accent-100 text-accent-900",
  "bg-secondary-100 text-secondary-900",
  "bg-primary-100 text-primary-800",
];

export default function Gossip() {
  return (
    <section id="gossip" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <Reveal>
          <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
            <SectionHeading
              eyebrow="Collections"
              title="吃瓜合集 · 按主题攒好了再给你"
              desc="把散落的片段按主题打包成合集，从剧组秘辛到红毯红黑榜，点开一篇就能顺着看完一整条线。"
            />
            <a href="#gossip" className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-semibold text-primary-700 transition-colors hover:text-primary-800">
              查看全部合集 <i className="ri-arrow-right-line" />
            </a>
          </div>
        </Reveal>

        <div className="mt-8 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {gossipCollections.map((g, idx) => (
            <Reveal key={g.id} delay={(idx % 3) * 80}>
              <a href="#gossip" className="group relative flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 p-5 transition-all hover:-translate-y-1 hover:border-primary-200 md:p-6">
                <span className={`inline-flex w-fit items-center gap-1 whitespace-nowrap rounded-full px-2.5 py-1 text-xs font-semibold ${palette[idx % palette.length]}`}>
                  {g.zone}
                </span>
                <h3 className="mt-4 font-heading text-lg font-bold leading-snug text-foreground-950 group-hover:text-primary-700 md:text-xl">{g.theme}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-700">{g.note}</p>
                <div className="mt-auto flex items-center justify-between border-t border-background-200 pt-4">
                  <span className="inline-flex items-center gap-1.5 text-sm text-foreground-600">
                    <i className="ri-archive-2-line text-base text-accent-700" /> {g.count} 篇收录
                  </span>
                  <span className="inline-flex items-center gap-1 text-xs text-foreground-500">
                    <i className="ri-time-line" /> {g.updated}
                  </span>
                </div>
                <span className="absolute -right-6 -top-6 h-16 w-16 rounded-full bg-accent-100/70 transition-transform duration-500 group-hover:scale-125" />
              </a>
            </Reveal>
          ))}

          {/* 一个 CTA 卡片收尾 */}
          <Reveal delay={160}>
            <a href="#gossip" className="group flex h-full flex-col items-start justify-center overflow-hidden rounded-lg bg-foreground-950 p-6 md:p-8">
              <span className="inline-flex h-11 w-11 items-center justify-center rounded-md bg-accent-500 text-foreground-950">
                <i className="ri-add-line text-2xl" />
              </span>
              <h3 className="mt-5 font-heading text-xl font-bold leading-snug text-background-50 md:text-2xl">你感兴趣的合集<br />还没有归档？</h3>
              <p className="mt-3 text-sm leading-relaxed text-background-50/70">到对应分区提一句想看的主题，运营会把它收进下一次盘点里。</p>
              <span className="mt-5 inline-flex items-center gap-1 whitespace-nowrap text-sm font-semibold text-accent-400">
                去提需求 <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
              </span>
            </a>
          </Reveal>
        </div>
      </div>
    </section>
  );
}